module.exports = __webpack_public_path__ + "img/WINTER HAT LIME.a7e0577.svg";